export { default } from './useChangelogRecordFeatureFlag';
